import React, { useState, useEffect } from 'react';

/**
 * NetworkStatus Component
 * Displays online/offline status and manages detection
 */
const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 Connection restored');
      setIsOnline(true);
      setShowNotification(true);
      
      // Trigger sync if service worker supports it
      if ('serviceWorker' in navigator && 'sync' in navigator.serviceWorker) {
        navigator.serviceWorker.ready.then((registration) => {
          return registration.sync.register('sync-pending-data');
        }).catch(err => console.error('Sync registration failed:', err));
      }
      
      // Hide notification after 3 seconds
      setTimeout(() => setShowNotification(false), 3000);
    };

    const handleOffline = () => {
      console.log('📴 Connection lost');
      setIsOnline(false);
      setShowNotification(true);
      
      // Hide notification after 5 seconds (offline is more critical, show longer)
      setTimeout(() => setShowNotification(false), 5000);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Status badge (always visible, top-right)
  const statusBadge = (
    <div className="fixed top-4 right-4 z-50 flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium shadow-lg transition-all"
      style={{
        backgroundColor: isOnline ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)',
        border: isOnline ? '1px solid rgba(34, 197, 94, 0.3)' : '1px solid rgba(239, 68, 68, 0.3)',
        color: isOnline ? '#22c55e' : '#ef4444'
      }}
    >
      <div className="w-2 h-2 rounded-full animate-pulse"
        style={{ backgroundColor: isOnline ? '#22c55e' : '#ef4444' }}
      />
      <span>{isOnline ? '☁️ Online' : '📴 Offline'}</span>
    </div>
  );

  // Toast notification (shows on status change)
  const notification = showNotification && (
    <div className="fixed top-20 right-4 z-50 animate-slide-in-right">
      <div className="px-4 py-3 rounded-lg shadow-xl max-w-sm"
        style={{
          backgroundColor: isOnline ? '#22c55e' : '#ef4444',
          color: 'white'
        }}
      >
        <div className="flex items-center gap-3">
          <div className="text-2xl">
            {isOnline ? '🌐' : '📴'}
          </div>
          <div>
            <div className="font-bold">
              {isOnline ? 'Connexion rétablie' : 'Mode Offline'}
            </div>
            <div className="text-sm opacity-90">
              {isOnline 
                ? 'Synchronisation en cours...' 
                : 'Vos données offline sont disponibles'
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {statusBadge}
      {notification}
    </>
  );
};

export default NetworkStatus;
